import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { DynamicDataTableComponent } from './dynamic-data-table.component';

@NgModule({
  declarations: [DynamicDataTableComponent],
  imports: [CommonModule, FormsModule],
  exports: [DynamicDataTableComponent],
})
export class DynamicDataTableModule {}
